// "Remember me" di halaman login: HANYA username yang diingat. Sandi tidak pernah disimpan di penyimpanan browser (teks biasa,
// terbaca siapa pun yang memakai browser itu); simpan sandi diserahkan ke pengelola sandi bawaan browser (kolom diberi
// autocomplete standar). Sandi lama yang terlanjur tersimpan oleh versi sebelumnya dihapus otomatis.
const KUNCI_USERNAME = 'username';
const KUNCI_INGAT = 'rememberMe';
const KUNCI_SANDI_LAMA = 'password';

export const bacaIngatLogin = (storage) => {
  try {
    storage.removeItem(KUNCI_SANDI_LAMA); // bersihkan sandi dari versi lama
    const ingat = storage.getItem(KUNCI_INGAT) === 'true';
    const username = ingat ? storage.getItem(KUNCI_USERNAME) || '' : '';
    return { ingat: ingat && !!username, username };
  } catch (e) {
    return { ingat: false, username: '' };
  }
};

export const simpanIngatLogin = (storage, { username, ingat }) => {
  try {
    storage.removeItem(KUNCI_SANDI_LAMA);
    if (ingat && username) {
      storage.setItem(KUNCI_USERNAME, username);
      storage.setItem(KUNCI_INGAT, 'true');
    } else {
      storage.removeItem(KUNCI_USERNAME);
      storage.removeItem(KUNCI_INGAT);
    }
  } catch (e) { /* penyimpanan diblokir: abaikan, login tetap jalan */ }
};

export const lupakanLogin = (storage) => simpanIngatLogin(storage, { username: '', ingat: false });
